const ApiConfig = {
  AuthConfig: {
    LOGIN: '/user/login',
    REGISTER: '/user/register',
    FORGOT_PASSWORD: '/user/password/recover',
    RESET_PASSWORD: '/user/password/reset',
    CHANGE_PASSWORD: '/user/password/change',
    CONFIRM_EMAIL: '/user/email/confirm',
    RESEND_CONFIRM_EMAIL: '/user/email/resend',
    USER_DETAIL: '/user',
    LOGOUT: '/user/logout',
    BUSINESS: '/business/register',
    UPDATE_BUSINESS: '/business?business=',
    CLOVER_AUTH: '/clover/auth',
    PLANS: '/business/subscription/stripe?business=',
  },
  DashboardConfig: {
    DASHBOARD: '/dashboard/?business=',
    DASHBOARD_INFO: '/dashboard/info?business=',
    DASHBOARD_CUSTOMERS: '/dashboard/existing-new-customers/?business=',
    DASHBOARD_ISSUED_REDEEMED: '/dashboard/issued-redeemed-rewards/?business=',
    DASHBOARD_REVENUE_DISCOUNTS: '/dashboard/revenue-discount/?business=',
    DASHBOARD_TOTAL_DISCOUNTS: '/dashboard/overall-discount/?business=',
    DASHBOARD_TOTAL_REVENUES: '/dashboard/overall-gross-revenue/?business=',
    DASHBOARD_REVENUE_OVER_TIME: '/dashboard/gross-revenue-over-time/?business=',
    DASHBOARD_CUSTOMER_OVER_TIME: '/dashboard/customers-enrolled-over-time/?business=',
    DASHBOARD_TOP_PROMOTIONS: '/dashboard/top-promotions?business=',
    DASHBOARD_REVENUE_COMPARISION: '/dashboard/promotion-revenue-comparison?business=',
    GIFT_SALES_OVER_TIME: '/dashboard/gift-sales-over-time?business=',
    GIFT_REDEEMED: 'dashboard/gift-redeemed-over-time?business=',
    GIFT_SALES_BY_PAYMENT: 'dashboard/gift-sales-payment?business=',
    GIFT_ISSUED: 'dashboard/gift-issued-redeemed?business=',
  },
  CommonConfig: {
    BUSINESS_TYPES: '/business/type',
    COUNTRY: '/country',
  },
  WidgetConfig: {
    WIDGET: '/widget?business=',
    EMBED: '/widget/embed-script?business=',
  },
  ProgramConfig: {
    PROGRAM: '/program?business=',
  },
  CustomerConfig: {
    CUSTOMER: '/customer?business=',
    CUSTOMER_LIST: '/customer',
    CUSTOMER_EXPORT: '/customer/export',
    CUSTOMER_TAGS: '/customer/tag',
    CUSTOMER_AUDIENCE: '/customer/audience',
    UPDATECUSTOMER: '/customer/:id/?business=',
    AVAILABLE_REWARDS: 'customer/:id/reward/?business=',
    ELIGIBLE_PROMOTIONS: 'promotion/eligible/?customer=:id&business=',
    REDEEM_PROMOTION: 'promotion/redeem/?promotion=:id&business=',
    REDEEM_REWARDS: 'customer/:id/reward/:rewardId/redeem/?business=',
    UNLINK_CARDS: 'customer/:id/card/:cardId/unlink?business=',
    COMMUNICATION_HISTORY: '/customer/:id/communication?business=',
    COMMUNICATION_PREVIEW: '/customer/:id/communication',
    REDEMPTION_HISTORY: 'customer/:id/reward_redeem?business=',
    EARNING_HISTORY: 'customer/:id/point-history?business=',
    ISSUE_GIFT: 'customer/gift/issue?business=',
    ISSUE_ALLOWANCE: 'customer/allowance/issue?business=',
    REDEEM_GIFT: 'customer/:id/gift/redeem?business=',
    RESEND_GIFT: 'customer/gift/:id/resend?business=',
    RESEND_ALLOWANCE: 'customer/allowance/:id/resend?business=',
    GIFT_HISTORY: 'customer/:id/gift?business=',
    GIFT_REDEEM: 'customer/:id/gift/redeem?business=',
    IMPORT_CUSTOMERS: '/customer/import?business=',
    ADD_POINTS: 'customer/:id/add-points?business=',
    REMOVE_POINTS: 'customer/:id/redeem-points?business=',
    REWARD_REDEEMED: 'customer/reward/redeemed',
    REWARD_REDEEMED_EXPORT: 'customer/reward/redeemed/export',
    GIFT_ISSUED: 'customer/gift/issued',
    GIFT_ISSUED_EXPORT: 'customer/gift/issued/export',
    ALLOWANCE_ISSUED: 'customer/allowance/issued',
    ALLOWANCE_ISSUED_EXPORT: 'customer/allowance/issued/export',
    GIFT_REDEEMED: 'customer/gift/redeemed',
    GIFT_REDEEMED_EXPORT: 'customer/gift/redeemed/export',
    ALLOWANCE_REDEEMED: 'customer/allowance/redeemed',
    ALLOWANCE_REDEEMED_EXPORT: 'customer/allowance/redeemed/export',
  },
  PartnerConfig: {
    Partner: '/partner?business=',
    PartnerGoogleBusinessAccounts: '/partner/google/business/account?business=',
    PartnerCloverConnect: '/partner/clover/user?business=',
    PartnerCloverDisconnect: '/partner/clover/disconnect?business=',
  },
  DeviceConfig: {
    CLOVER_DEVICES: 'device/clover?business=',
    DESKTOP_DEVICES: 'device/desktop?business=',
  },
  SurveyConfig: {
    QuestionTypes: '/feedback/answer-type?business=',
    SurveyQuestions: '/feedback/question?business=',
    CreateSurveyQuestion: '/feedback/question',
    Reviews: '/business/review?business=',
  },
  PromotionConfig: {
    PROMOTIONS: 'promotion/:id?business=',
  },
  BrandConfig: {
    Brand: 'brand?business=',
  },
  CardDesignConfig: {
    CardDesign: 'card-design?business=',
  },
  GiftCardDesignConfig: {
    GiftCardDesign: 'gift-card-design?business=',
  },
  AllowanceCardDesignConfig: {
    AllowanceCardDesign: 'allowance-card-design?business=',
  },
  SubscriptionConfig: {
    LOAD_SUBSCRIPTION: 'subscription',
    LOAD_PRODUCTS: 'subscription/product',
    LOAD_PRODUCTS_SHOPIFY: 'subscription/product/shopify',
    LOAD_INVOICES: 'subscription/invoice',
    UPDATE_SUBSCRIPTION: 'subscription',
    UPDATE_WALLET_AUTO_RECHARGE_SETTINGS: 'subscription/wallet/auto-recharge',
    ADD_FUND_TO_WALLET: 'subscription/wallet/add-fund',
  },
  AssistantConfig: {
    ASSISTANT: 'assistant',
  },
  InboxConfig: {
    LOAD_INBOXES: 'inbox',
    LOAD_INBOX_COUNT: 'inbox/count',
  },
  DigitalSignageConfig: {
    LOAD_DIGITAL_SIGNAGES: 'digital-signage',
  },
  BusinessConfig: {
    BUSINESS_USERS: 'business/user',
  },
  CommunicationConfig: {
    COMMUNICATION: '/communication',
    VOICE: 'communication/voice',
    VOICE_EXPORT: 'communication/voice/export',
  },
  ItemConfig: {
    ITEMS: '/business/item',
  },
  ReportConfig: {
    SALES_SUMMARY: '/report/sales-summary',
  },
}

export default ApiConfig
